import { useCallback, useContext } from 'react';
import { Button, Collapse } from 'reactstrap';
import { Block } from '../Block';
import { FlexStartRow, FormContext } from './FormElements';
import Chip from './Chip';
import Input from './Input';

const defaultInputProps = {};

const EmailRecipients = ({
    emailAddresses,
    onEmailAdded,
    onEmailChanged,
    onEmailRemoved,
    currentEmailAddress,
    readOnly,
    readOnlyAddresses,
    InputProps = defaultInputProps,
}) => {
    const context = useContext(FormContext);
    const savedEmails = (emailAddresses || []).filter(Boolean);

    const handleEmailAdded = useCallback(() => {
        onEmailAdded();
        context?.setFieldValue('__email', '');
    }, [onEmailAdded, context]);

    return (
        <Block>
            {!readOnly && (
                <Input
                    id="__email"
                    name="__email"
                    placeholder="ex: person@provider.com"
                    autoComplete="off"
                    type="email"
                    onChange={onEmailChanged}
                    value={currentEmailAddress ?? ''}
                    onKeyDown={(e) => {
                        if (e.keyCode === 13) {
                            e.preventDefault();
                            handleEmailAdded();
                        }
                    }}
                    endAddonContained={false}
                    endAddon={(
                        <Button
                            type="button"
                            color="primary"
                            disabled={!currentEmailAddress}
                            onClick={handleEmailAdded}
                        >
                            Add
                        </Button>
                    )}
                    {...InputProps}
                />
            )}

            <Collapse isOpen={savedEmails.length > 0}>
                <FlexStartRow
                    className="flex-wrap mt-3"
                    style={{ gap: '0.5rem' }}
                >
                    {savedEmails.map((email) => (
                        <Chip
                            key={email}
                            text={email}
                            color="white"
                            onRemove={
                                !readOnly &&
                                    !(readOnlyAddresses ?? []).includes(email)
                                    ? () => onEmailRemoved(email)
                                    : null
                            }
                        />
                    ))}
                </FlexStartRow>
            </Collapse>
        </Block>
    );
};

export default EmailRecipients;
